import { render, staticRenderFns } from "./editBlogs.vue?vue&type=template&id=139018e7&scoped=true"
import script from "./editBlogs.vue?vue&type=script&lang=js"
export * from "./editBlogs.vue?vue&type=script&lang=js"
import style0 from "./editBlogs.vue?vue&type=style&index=0&id=139018e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139018e7",
  null
  
)

export default component.exports